const categoriesDict = {
  "133": {
    "cat_id": "133",
    "cat_name": "Toys Hobbies and Robot",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "265",
        "cat_name": "Dolls & Stuffed Toys",
        "parent_id": "133"
      },
      {
        "cat_id": "1423",
        "cat_name": "Learning & Education",
        "parent_id": "133"
      },
      {
        "cat_id": "1780",
        "cat_name": "Musical Instruments",
        "parent_id": "133"
      },
      {
        "cat_id": "3993",
        "cat_name": "RC Robot",
        "parent_id": "133"
      },
      {
        "cat_id": "4475",
        "cat_name": "Model & Building Toys",
        "parent_id": "133"
      },
      {
        "cat_id": "8767",
        "cat_name": "RC Drones",
        "parent_id": "133"
      },
      {
        "cat_id": "8768",
        "cat_name": "RC Parts",
        "parent_id": "133"
      },
      {
        "cat_id": "8769",
        "cat_name": "RC Vehicles",
        "parent_id": "133"
      },
      {
        "cat_id": "8780",
        "cat_name": "Novelty & Gagdet Toys",
        "parent_id": "133"
      },
      {
        "cat_id": "13147",
        "cat_name": "Baby & Toddler Toys",
        "parent_id": "133"
      }
    ]
  },
  "155": {
    "cat_id": "155",
    "cat_name": "Computers & Office",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "422",
        "cat_name": "Drives and Storage",
        "parent_id": "155"
      },
      {
        "cat_id": "427",
        "cat_name": "Laptops Accessories",
        "parent_id": "155"
      },
      {
        "cat_id": "428",
        "cat_name": "Tablet PC",
        "parent_id": "155"
      },
      {
        "cat_id": "429",
        "cat_name": "Networking",
        "parent_id": "155"
      },
      {
        "cat_id": "1958",
        "cat_name": "Computer Cables & Connectors",
        "parent_id": "155"
      },
      {
        "cat_id": "1977",
        "cat_name": "Computer Components",
        "parent_id": "155"
      },
      {
        "cat_id": "2187",
        "cat_name": "Mini PC & Accessories",
        "parent_id": "155"
      },
      {
        "cat_id": "4335",
        "cat_name": "Computer Peripherals",
        "parent_id": "155"
      },
      {
        "cat_id": "10687",
        "cat_name": "Laptops & Netbooks",
        "parent_id": "155"
      },
      {
        "cat_id": "10688",
        "cat_name": "DIY Computers",
        "parent_id": "155"
      },
      {
        "cat_id": "10689",
        "cat_name": "Desktops",
        "parent_id": "155"
      },
      {
        "cat_id": "10690",
        "cat_name": "All-In-One",
        "parent_id": "155"
      },
      {
        "cat_id": "10691",
        "cat_name": "Tablet Accessories",
        "parent_id": "155"
      },
      {
        "cat_id": "10716",
        "cat_name": "Projectors & Accessories",
        "parent_id": "155"
      },
      {
        "cat_id": "10723",
        "cat_name": "Office Equipment",
        "parent_id": "155"
      },
      {
        "cat_id": "10744",
        "cat_name": "Desk Accessories & Workspace Organizers",
        "parent_id": "155"
      },
      {
        "cat_id": "10755",
        "cat_name": "Stationery",
        "parent_id": "155"
      }
    ]
  },
  "170": {
    "cat_id": "170",
    "cat_name": "Jewelry,Watches & Accessories",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "273",
        "cat_name": "Men Watches",
        "parent_id": "170"
      },
      {
        "cat_id": "378",
        "cat_name": "Jewelry Supplies",
        "parent_id": "170"
      },
      {
        "cat_id": "1679",
        "cat_name": "Repair Tools & Kits",
        "parent_id": "170"
      },
      {
        "cat_id": "1726",
        "cat_name": "Keychain & Ornaments",
        "parent_id": "170"
      },
      {
        "cat_id": "2179",
        "cat_name": "Watch Accessories",
        "parent_id": "170"
      },
      {
        "cat_id": "2312",
        "cat_name": "Men Jewelry",
        "parent_id": "170"
      },
      {
        "cat_id": "2433",
        "cat_name": "Jewelry",
        "parent_id": "170"
      },
      {
        "cat_id": "2761",
        "cat_name": "Kid's Jewelry & DIY",
        "parent_id": "170"
      },
      {
        "cat_id": "2890",
        "cat_name": "Women Watches",
        "parent_id": "170"
      },
      {
        "cat_id": "3501",
        "cat_name": "Fine Jewelry",
        "parent_id": "170"
      },
      {
        "cat_id": "11027",
        "cat_name": "Nurse\u00a0Watches",
        "parent_id": "170"
      },
      {
        "cat_id": "11028",
        "cat_name": "Couple\u00a0Watches",
        "parent_id": "170"
      },
      {
        "cat_id": "11029",
        "cat_name": "Children\u00a0Watches",
        "parent_id": "170"
      }
    ]
  },
  "892": {
    "cat_id": "892",
    "cat_name": "Health,Beauty & Hair",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "851",
        "cat_name": "Tattoos & Body Art",
        "parent_id": "892"
      },
      {
        "cat_id": "893",
        "cat_name": "Health Care",
        "parent_id": "892"
      },
      {
        "cat_id": "895",
        "cat_name": "Hair & Accessories",
        "parent_id": "892"
      },
      {
        "cat_id": "931",
        "cat_name": "Makeup",
        "parent_id": "892"
      },
      {
        "cat_id": "1060",
        "cat_name": "Nail Art & Tools",
        "parent_id": "892"
      },
      {
        "cat_id": "1985",
        "cat_name": "Skin Care",
        "parent_id": "892"
      },
      {
        "cat_id": "1986",
        "cat_name": "Shavers and Hair Removal",
        "parent_id": "892"
      },
      {
        "cat_id": "2420",
        "cat_name": "Teeth & Mouth Care",
        "parent_id": "892"
      },
      {
        "cat_id": "10855",
        "cat_name": "Hair Care & Styling",
        "parent_id": "892"
      },
      {
        "cat_id": "12292",
        "cat_name": "Beauty Equipment",
        "parent_id": "892"
      },
      {
        "cat_id": "12609",
        "cat_name": "Sex Products",
        "parent_id": "892"
      }
    ]
  },
  "896": {
    "cat_id": "896",
    "cat_name": "Sports & Outdoor",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "897",
        "cat_name": "Fitness & Body Building",
        "parent_id": "896"
      },
      {
        "cat_id": "1087",
        "cat_name": "Outdoor Recreation",
        "parent_id": "896"
      },
      {
        "cat_id": "1116",
        "cat_name": "Camping",
        "parent_id": "896"
      },
      {
        "cat_id": "1716",
        "cat_name": "Bike & Bicycle",
        "parent_id": "896"
      },
      {
        "cat_id": "2096",
        "cat_name": "Travel Supplies",
        "parent_id": "896"
      },
      {
        "cat_id": "5227",
        "cat_name": "Outdoors Clothing & Shoes",
        "parent_id": "896"
      },
      {
        "cat_id": "5658",
        "cat_name": "Team Sport",
        "parent_id": "896"
      },
      {
        "cat_id": "6252",
        "cat_name": "Hiking & Climbing",
        "parent_id": "896"
      },
      {
        "cat_id": "7937",
        "cat_name": "Fishing & Hunting",
        "parent_id": "896"
      },
      {
        "cat_id": "9158",
        "cat_name": "Children Sport",
        "parent_id": "896"
      },
      {
        "cat_id": "10566",
        "cat_name": "Entertainment",
        "parent_id": "896"
      }
    ]
  },
  "1031": {
    "cat_id": "1031",
    "cat_name": "Home and Garden",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "1032",
        "cat_name": "Housekeeping & Organization",
        "parent_id": "1031"
      },
      {
        "cat_id": "1037",
        "cat_name": "Gardening",
        "parent_id": "1031"
      },
      {
        "cat_id": "1039",
        "cat_name": "Kitchen,Dining & Bar",
        "parent_id": "1031"
      },
      {
        "cat_id": "1093",
        "cat_name": "Festival Gifts & Party Supplies",
        "parent_id": "1031"
      },
      {
        "cat_id": "1801",
        "cat_name": "Bathroom",
        "parent_id": "1031"
      },
      {
        "cat_id": "1805",
        "cat_name": "Home Decor",
        "parent_id": "1031"
      },
      {
        "cat_id": "2703",
        "cat_name": "Home Textiles",
        "parent_id": "1031"
      },
      {
        "cat_id": "13170",
        "cat_name": "Household Merchandises",
        "parent_id": "1031"
      }
    ]
  },
  "1134": {
    "cat_id": "1134",
    "cat_name": "Automobiles & Motorcycles",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "175",
        "cat_name": "Car Electronics",
        "parent_id": "1134"
      },
      {
        "cat_id": "177",
        "cat_name": "Car Audio & Monitor",
        "parent_id": "1134"
      },
      {
        "cat_id": "179",
        "cat_name": "GPS & Accessories",
        "parent_id": "1134"
      },
      {
        "cat_id": "227",
        "cat_name": "Car Alarm & Security",
        "parent_id": "1134"
      },
      {
        "cat_id": "1374",
        "cat_name": "Car Lights",
        "parent_id": "1134"
      },
      {
        "cat_id": "1736",
        "cat_name": "Auto Parts",
        "parent_id": "1134"
      },
      {
        "cat_id": "1749",
        "cat_name": "Interior Accessories",
        "parent_id": "1134"
      },
      {
        "cat_id": "1756",
        "cat_name": "Motorcycle Accessories & Parts",
        "parent_id": "1134"
      },
      {
        "cat_id": "2034",
        "cat_name": "Car DVRs",
        "parent_id": "1134"
      },
      {
        "cat_id": "2193",
        "cat_name": "Car Repair Tools",
        "parent_id": "1134"
      },
      {
        "cat_id": "2310",
        "cat_name": "Exterior Accessories",
        "parent_id": "1134"
      },
      {
        "cat_id": "2311",
        "cat_name": "Car Repair & Maintenance",
        "parent_id": "1134"
      },
      {
        "cat_id": "4521",
        "cat_name": "Boat",
        "parent_id": "1134"
      },
      {
        "cat_id": "4650",
        "cat_name": "Agricultural Machinery",
        "parent_id": "1134"
      },
      {
        "cat_id": "11005",
        "cat_name": "Other Vehicle Parts & Accessories",
        "parent_id": "1134"
      }
    ]
  },
  "1697": {
    "cat_id": "1697",
    "cat_name": "Lights & Lighting",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "1057",
        "cat_name": "Flashlight",
        "parent_id": "1697"
      },
      {
        "cat_id": "1627",
        "cat_name": "LED\u00a0Bulbs\u00a0&\u00a0Tubes",
        "parent_id": "1697"
      },
      {
        "cat_id": "1698",
        "cat_name": "Lasers",
        "parent_id": "1697"
      },
      {
        "cat_id": "1988",
        "cat_name": "Decor & Gadget Lights",
        "parent_id": "1697"
      },
      {
        "cat_id": "2512",
        "cat_name": "LED Strip",
        "parent_id": "1697"
      },
      {
        "cat_id": "2514",
        "cat_name": "Indoor Lighting",
        "parent_id": "1697"
      },
      {
        "cat_id": "2518",
        "cat_name": "Lighting Accessories",
        "parent_id": "1697"
      },
      {
        "cat_id": "5495",
        "cat_name": "Outdoor Lighting",
        "parent_id": "1697"
      },
      {
        "cat_id": "10411",
        "cat_name": "Smart\u00a0Light",
        "parent_id": "1697"
      },
      {
        "cat_id": "10633",
        "cat_name": "Commercial Lighting",
        "parent_id": "1697"
      }
    ]
  },
  "2006": {
    "cat_id": "2006",
    "cat_name": "Home Appliances",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "5580",
        "cat_name": "Kitchen Appliances",
        "parent_id": "2006"
      },
      {
        "cat_id": "5648",
        "cat_name": "Cleaning Appliances",
        "parent_id": "2006"
      },
      {
        "cat_id": "5650",
        "cat_name": "Air Conditioning Appliances",
        "parent_id": "2006"
      },
      {
        "cat_id": "6564",
        "cat_name": "Personal Care Appliances",
        "parent_id": "2006"
      },
      {
        "cat_id": "8642",
        "cat_name": "Household Appliances",
        "parent_id": "2006"
      },
      {
        "cat_id": "8646",
        "cat_name": "Home Appliance Parts",
        "parent_id": "2006"
      },
      {
        "cat_id": "12684",
        "cat_name": "Commercial Appliance",
        "parent_id": "2006"
      }
    ]
  },
  "9875": {
    "cat_id": "9875",
    "cat_name": "Luggage & Bags",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "9876",
        "cat_name": "Women's Bags",
        "parent_id": "9875"
      },
      {
        "cat_id": "9877",
        "cat_name": "Luggage & Travel Bags",
        "parent_id": "9875"
      },
      {
        "cat_id": "9878",
        "cat_name": "Special Purpose Luggage & Bags",
        "parent_id": "9875"
      },
      {
        "cat_id": "9879",
        "cat_name": "Men's Bags",
        "parent_id": "9875"
      }
    ]
  },
  "9909": {
    "cat_id": "9909",
    "cat_name": "Shoes",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "9910",
        "cat_name": "Women's Shoes",
        "parent_id": "9909"
      },
      {
        "cat_id": "9915",
        "cat_name": "Men's Shoes",
        "parent_id": "9909"
      },
      {
        "cat_id": "9922",
        "cat_name": "Shoe Accessories",
        "parent_id": "9909"
      }
    ]
  },
  "9995": {
    "cat_id": "9995",
    "cat_name": "Apparel Accessories",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "9996",
        "cat_name": "Men's Accessories",
        "parent_id": "9995"
      },
      {
        "cat_id": "10010",
        "cat_name": "Women's Accessories",
        "parent_id": "9995"
      }
    ]
  },
  "10028": {
    "cat_id": "10028",
    "cat_name": "Women's Clothing",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "10029",
        "cat_name": "Activewear",
        "parent_id": "10028"
      },
      {
        "cat_id": "10043",
        "cat_name": "Bottoms",
        "parent_id": "10028"
      },
      {
        "cat_id": "10050",
        "cat_name": "Dresses",
        "parent_id": "10028"
      },
      {
        "cat_id": "10058",
        "cat_name": "Tops",
        "parent_id": "10028"
      },
      {
        "cat_id": "10065",
        "cat_name": "Lingerie",
        "parent_id": "10028"
      },
      {
        "cat_id": "10078",
        "cat_name": "Sleepwear",
        "parent_id": "10028"
      },
      {
        "cat_id": "10085",
        "cat_name": "Two-Piece Set",
        "parent_id": "10028"
      },
      {
        "cat_id": "10086",
        "cat_name": "Swimwear",
        "parent_id": "10028"
      },
      {
        "cat_id": "10090",
        "cat_name": "Outerwear",
        "parent_id": "10028"
      },
      {
        "cat_id": "10100",
        "cat_name": "Plus Size",
        "parent_id": "10028"
      }
    ]
  },
  "10128": {
    "cat_id": "10128",
    "cat_name": "Wedding & Events",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "10129",
        "cat_name": "Wedding Dresses",
        "parent_id": "10128"
      },
      {
        "cat_id": "10130",
        "cat_name": "Wedding Party Dresses",
        "parent_id": "10128"
      },
      {
        "cat_id": "10131",
        "cat_name": "Special Occasion Dresses",
        "parent_id": "10128"
      },
      {
        "cat_id": "10132",
        "cat_name": "Wedding Decor Supplies",
        "parent_id": "10128"
      },
      {
        "cat_id": "10133",
        "cat_name": "Wedding Accessories",
        "parent_id": "10128"
      }
    ]
  },
  "10148": {
    "cat_id": "10148",
    "cat_name": "Mother & Kids",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "10149",
        "cat_name": "Safety Gear",
        "parent_id": "10148"
      },
      {
        "cat_id": "10156",
        "cat_name": "Activity & Gear",
        "parent_id": "10148"
      },
      {
        "cat_id": "10212",
        "cat_name": "Baby & Kids Care",
        "parent_id": "10148"
      },
      {
        "cat_id": "10232",
        "cat_name": "Feeding Supplies",
        "parent_id": "10148"
      },
      {
        "cat_id": "10240",
        "cat_name": "Diapering & Toilet Training",
        "parent_id": "10148"
      },
      {
        "cat_id": "10255",
        "cat_name": "Pregnancy & Maternity",
        "parent_id": "10148"
      },
      {
        "cat_id": "10264",
        "cat_name": "Baby Souvenirs",
        "parent_id": "10148"
      },
      {
        "cat_id": "10267",
        "cat_name": "Kids Shoes",
        "parent_id": "10148"
      },
      {
        "cat_id": "10268",
        "cat_name": "Baby Shoes",
        "parent_id": "10148"
      },
      {
        "cat_id": "10276",
        "cat_name": "Girl's Clothing",
        "parent_id": "10148"
      },
      {
        "cat_id": "10285",
        "cat_name": "Boy 's Clothing",
        "parent_id": "10148"
      },
      {
        "cat_id": "10294",
        "cat_name": "Baby Clothing",
        "parent_id": "10148"
      },
      {
        "cat_id": "10300",
        "cat_name": "Maternity 's Clothing",
        "parent_id": "10148"
      },
      {
        "cat_id": "10307",
        "cat_name": "Kids Bags",
        "parent_id": "10148"
      },
      {
        "cat_id": "10314",
        "cat_name": "Kids'Accessories",
        "parent_id": "10148"
      },
      {
        "cat_id": "12965",
        "cat_name": "Bedding",
        "parent_id": "10148"
      }
    ]
  },
  "10166": {
    "cat_id": "10166",
    "cat_name": "Men's Clothing",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "10168",
        "cat_name": "Tops",
        "parent_id": "10166"
      },
      {
        "cat_id": "10176",
        "cat_name": "Bottoms",
        "parent_id": "10166"
      },
      {
        "cat_id": "10179",
        "cat_name": "Outwear",
        "parent_id": "10166"
      },
      {
        "cat_id": "10191",
        "cat_name": "Activewear",
        "parent_id": "10166"
      },
      {
        "cat_id": "10195",
        "cat_name": "Outdoors",
        "parent_id": "10166"
      },
      {
        "cat_id": "10198",
        "cat_name": "Sleepwear",
        "parent_id": "10166"
      },
      {
        "cat_id": "10203",
        "cat_name": "Underwear",
        "parent_id": "10166"
      },
      {
        "cat_id": "10209",
        "cat_name": "Swimwear",
        "parent_id": "10166"
      },
      {
        "cat_id": "13410",
        "cat_name": "Plus Size",
        "parent_id": "10166"
      },
      {
        "cat_id": "13885",
        "cat_name": "Two Pieces Set",
        "parent_id": "10166"
      }
    ]
  },
  "11050": {
    "cat_id": "11050",
    "cat_name": "Phones & Telecommunications",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "11051",
        "cat_name": "Telephones",
        "parent_id": "11050"
      },
      {
        "cat_id": "11056",
        "cat_name": "Mobile Phones",
        "parent_id": "11050"
      },
      {
        "cat_id": "11063",
        "cat_name": "Mobile Phone Accessories",
        "parent_id": "11050"
      },
      {
        "cat_id": "11408",
        "cat_name": "Mobile Phone Parts",
        "parent_id": "11050"
      },
      {
        "cat_id": "11424",
        "cat_name": "Communication Equipments",
        "parent_id": "11050"
      }
    ]
  },
  "11078": {
    "cat_id": "11078",
    "cat_name": "Electronic Components & Supplies",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "11079",
        "cat_name": "Motherboard & Development Board",
        "parent_id": "11078"
      },
      {
        "cat_id": "11080",
        "cat_name": "Module Components",
        "parent_id": "11078"
      },
      {
        "cat_id": "11081",
        "cat_name": "EL Products",
        "parent_id": "11078"
      },
      {
        "cat_id": "11082",
        "cat_name": "Electronic Accessories & Supplies",
        "parent_id": "11078"
      },
      {
        "cat_id": "11083",
        "cat_name": "DIY Electronic Kits",
        "parent_id": "11078"
      },
      {
        "cat_id": "11084",
        "cat_name": "Electronic Signs",
        "parent_id": "11078"
      },
      {
        "cat_id": "11099",
        "cat_name": "Module Board",
        "parent_id": "11078"
      }
    ]
  },
  "11123": {
    "cat_id": "11123",
    "cat_name": "Consumer Electronics",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "11124",
        "cat_name": "Photography & Camera Acc",
        "parent_id": "11123"
      },
      {
        "cat_id": "11161",
        "cat_name": "Home Audio & Video",
        "parent_id": "11123"
      },
      {
        "cat_id": "11245",
        "cat_name": "Video Games Equipment & Accessories",
        "parent_id": "11123"
      },
      {
        "cat_id": "11285",
        "cat_name": "Audio & Video Devices",
        "parent_id": "11123"
      },
      {
        "cat_id": "11315",
        "cat_name": "Smart Wearable Device",
        "parent_id": "11123"
      },
      {
        "cat_id": "11320",
        "cat_name": "Smart Wearable Device Accessories",
        "parent_id": "11123"
      },
      {
        "cat_id": "11323",
        "cat_name": "Smart Home",
        "parent_id": "11123"
      },
      {
        "cat_id": "11336",
        "cat_name": "Digital Accessories",
        "parent_id": "11123"
      }
    ]
  },
  "11434": {
    "cat_id": "11434",
    "cat_name": "Pet Supplies",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "11435",
        "cat_name": "Dog Supplies",
        "parent_id": "11434"
      },
      {
        "cat_id": "11447",
        "cat_name": "Cat Supplies",
        "parent_id": "11434"
      },
      {
        "cat_id": "11457",
        "cat_name": "Fish & Aquatic Pets Supplies",
        "parent_id": "11434"
      },
      {
        "cat_id": "11468",
        "cat_name": "Bird Supplies",
        "parent_id": "11434"
      },
      {
        "cat_id": "11472",
        "cat_name": "Reptile & Amphibian Supplies",
        "parent_id": "11434"
      },
      {
        "cat_id": "11473",
        "cat_name": "Hamster",
        "parent_id": "11434"
      },
      {
        "cat_id": "11474",
        "cat_name": "Farm",
        "parent_id": "11434"
      },
      {
        "cat_id": "11475",
        "cat_name": "Horse",
        "parent_id": "11434"
      },
      {
        "cat_id": "11476",
        "cat_name": "Insect Supplies",
        "parent_id": "11434"
      },
      {
        "cat_id": "11477",
        "cat_name": "Beekeeping Supplies",
        "parent_id": "11434"
      },
      {
        "cat_id": "11480",
        "cat_name": "Pet Memorials",
        "parent_id": "11434"
      },
      {
        "cat_id": "13145",
        "cat_name": "Pet Medical Supplies",
        "parent_id": "11434"
      }
    ]
  },
  "11482": {
    "cat_id": "11482",
    "cat_name": "Industrial & Scientific",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "11483",
        "cat_name": "Laser Equipment",
        "parent_id": "11482"
      },
      {
        "cat_id": "11490",
        "cat_name": "Raw Materials",
        "parent_id": "11482"
      },
      {
        "cat_id": "11499",
        "cat_name": "Lab & Scientific Supplies",
        "parent_id": "11482"
      },
      {
        "cat_id": "11538",
        "cat_name": "Electrical Equipment & Supplies",
        "parent_id": "11482"
      }
    ]
  },
  "11597": {
    "cat_id": "11597",
    "cat_name": "Security & Protection",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "11598",
        "cat_name": "Security & Surveillance",
        "parent_id": "11597"
      },
      {
        "cat_id": "11631",
        "cat_name": "Walkie Talkies",
        "parent_id": "11597"
      },
      {
        "cat_id": "11643",
        "cat_name": "Access Control",
        "parent_id": "11597"
      },
      {
        "cat_id": "11648",
        "cat_name": "Labor Insurance Supplies",
        "parent_id": "11597"
      },
      {
        "cat_id": "11678",
        "cat_name": "Fire Protection",
        "parent_id": "11597"
      },
      {
        "cat_id": "11705",
        "cat_name": "Disaster-relief Supplies",
        "parent_id": "11597"
      },
      {
        "cat_id": "11726",
        "cat_name": "Safes",
        "parent_id": "11597"
      },
      {
        "cat_id": "11736",
        "cat_name": "Roadway Safety",
        "parent_id": "11597"
      },
      {
        "cat_id": "11743",
        "cat_name": "Security Inspection Device",
        "parent_id": "11597"
      }
    ]
  },
  "11756": {
    "cat_id": "11756",
    "cat_name": "Tools",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "11757",
        "cat_name": "Professional Tools",
        "parent_id": "11756"
      },
      {
        "cat_id": "11791",
        "cat_name": "Tool Organizers",
        "parent_id": "11756"
      },
      {
        "cat_id": "11798",
        "cat_name": "Measurement & Analysis Instruments",
        "parent_id": "11756"
      },
      {
        "cat_id": "11848",
        "cat_name": "Tool Accessories",
        "parent_id": "11756"
      },
      {
        "cat_id": "11884",
        "cat_name": "Machine Tools & Accessories",
        "parent_id": "11756"
      },
      {
        "cat_id": "11934",
        "cat_name": "Hand Tools",
        "parent_id": "11756"
      },
      {
        "cat_id": "11956",
        "cat_name": "Power Tools",
        "parent_id": "11756"
      },
      {
        "cat_id": "13810",
        "cat_name": "Woodworking Tools",
        "parent_id": "11756"
      },
      {
        "cat_id": "13835",
        "cat_name": "Gardening Tools",
        "parent_id": "11756"
      },
      {
        "cat_id": "13883",
        "cat_name": "Security Tools",
        "parent_id": "11756"
      }
    ]
  },
  "11975": {
    "cat_id": "11975",
    "cat_name": "Furniture & Home Improvement",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "11976",
        "cat_name": "Furniture",
        "parent_id": "11975"
      },
      {
        "cat_id": "12050",
        "cat_name": "Office Furniture",
        "parent_id": "11975"
      },
      {
        "cat_id": "12068",
        "cat_name": "Furniture Accessories",
        "parent_id": "11975"
      },
      {
        "cat_id": "12098",
        "cat_name": "Home Improvement",
        "parent_id": "11975"
      }
    ]
  },
  "13611": {
    "cat_id": "13611",
    "cat_name": "Special Category",
    "parent_id": "0",
    "subcategories": [
      {
        "cat_id": "13612",
        "cat_name": "Gift Card",
        "parent_id": "13611"
      },
      {
        "cat_id": "13792",
        "cat_name": "Discount Card",
        "parent_id": "13611"
      }
    ]
  }
}
export default categoriesDict;
